import React from 'react';
import { Dialog, IconButton, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import zenRadarImage1 from '../../../utilities/images/ZenRadar/ZenRadarDialog1.png';
import zenRadarImage2 from '../../../utilities/images/ZenRadar/ZenRadarDialog2.png';
import zenRadarImage3 from '../../../utilities/images/ZenRadar/ZenRadarDialog3.png';
import zenRadarImage4 from '../../../utilities/images/ZenRadar/ZenRadarDialog4.png';
import zenRadarImage5 from '../../../utilities/images/ZenRadar/ZenRadarDialog5.png';
import ImageCarousel from './ImageCarousel';
import './Projects.css';
import { t } from 'i18next';
import SlideUpTransition from '../SlideUpTransition';
import ProjectActionButtons from './ProjectActionButtons';

interface ZenRadarDialogProps {
    open: boolean;
    onClose: () => void;
}

const ZenRadarDialog: React.FC<ZenRadarDialogProps> = ({ open, onClose }) => {
    const isCompactScreen = useMediaQuery('(max-width: 768px)');

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isCompactScreen}
            TransitionComponent={SlideUpTransition}
            sx={{
                '& .MuiDialog-paper': {
                    margin: isCompactScreen ? 0 : 2,
                    width: isCompactScreen ? '100vw' : 'auto',
                    maxWidth: isCompactScreen ? '100vw' : 'min(92vw, 960px)',
                    maxHeight: isCompactScreen ? '100dvh' : '95dvh',
                    borderRadius: isCompactScreen ? 0 : 3,
                    overflow: isCompactScreen ? 'auto' : 'hidden',
                },
            }}
        >
            <div className="card">
                <IconButton aria-label="Close dialog" onClick={onClose} className="dialog-close-button" size="small">
                    <CloseIcon fontSize="small" />
                </IconButton>
                
                <div className="title">{t("projectDialogs.zenRadar.title")}</div>
                
                <div className="card-content">
                    <ImageCarousel
                        images={[zenRadarImage1, zenRadarImage2, zenRadarImage3, zenRadarImage4, zenRadarImage5]}
                        alt={t("projectDialogs.zenRadar.title")}
                    />
                    
                    <div className="description">
                        <div className="left-box">
                            {t("projectDialogs.zenRadar.description")}
                        </div>
                        
                        <div className="right-box">
                            <div>Flutter</div>
                            <div>Dart</div>
                            <div>Material UI</div>
                            <div>SQLite</div>
                            <div>Android</div>
                        </div>
                    </div>
                </div>
                
                <ProjectActionButtons
                    githubUrl="https://github.com/SirArchy/ZenRadar"
                    googlePlayUrl="https://play.google.com/store/apps/details?id=com.yourdomain.zenradar"
                />
            </div>
        </Dialog>
    );
};

export default ZenRadarDialog;